<template>
    <v-container>
        <h1>Payment Receipt</h1>
        <h3>Account Information</h3>

        <table>
            <thead>
                <tr>
                    <th>Account Activity</th>
                    <th>Term</th>
                    <th>Date</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in billing_data" v-bind:key="item.code">
                    <td>{{ item.description }}</td>
                    <td>{{ item.term }}</td>
                    <td>{{ item.date }}</td>
                    <td>${{ item.amount }}</td>
                </tr>
            </tbody>
        </table>

    </v-container>
</template>
<script>
export default {
    mounted() {
        this.$store.dispatch('fetchBillingData')
            .then((resp) => {
                window.console.log('BILLING RESPONSE: ' + this.billing_data)
                window.console.log(resp.data)
            })
    },

    computed: {
        billing_data: function() {
            return this.$store.state.billing_data
        }
    }
}
</script>
